var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsCounter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6925 31.4633H19.9903L20.6502 31.4652C26.255 31.4954 39.385 32.0102 39.385 40.7613C39.385 48.8749 28.6015 49.9591 20.2135 50L18.7348 49.9994C13.13 49.9691 0 49.4545 0 40.7057C0 32.4206 11.2375 31.4633 19.6925 31.4633ZM19.6925 35.2522C9.115 35.2522 3.75 37.0886 3.75 40.7057C3.75 44.3583 9.115 46.2123 19.6925 46.2123C30.27 46.2123 35.635 44.3759 35.635 40.7613C35.635 37.1037 30.27 35.2522 19.6925 35.2522ZM43.0102 14.9504C44.0452 14.9504 44.8852 15.7991 44.8852 16.8448L44.885 20.0131L48.125 20.0152C49.16 20.0152 50 20.8639 50 21.9096C50 22.9554 49.16 23.8041 48.125 23.8041L44.885 23.8021L44.8852 26.9764C44.8852 28.0222 44.0452 28.8709 43.0102 28.8709C41.9752 28.8709 41.1352 28.0222 41.1352 26.9764L41.135 23.8021L37.9 23.8041C36.865 23.8041 36.025 22.9554 36.025 21.9096C36.025 20.8639 36.865 20.0152 37.9 20.0152L41.135 20.0131L41.1352 16.8448C41.1352 15.7991 41.9752 14.9504 43.0102 14.9504ZM19.6925 0C27.025 0 32.9875 6.02692 32.9875 13.433C32.9875 20.8391 27.025 26.866 19.6925 26.866H19.615C16.0675 26.8534 12.7425 25.4465 10.25 22.9104C7.755 20.3718 6.3875 17.0022 6.39992 13.4254C6.39992 6.02693 12.3625 0 19.6925 0ZM19.6925 3.78893C14.4325 3.78893 10.1499 8.11589 10.1499 13.433C10.14 16.007 11.12 18.4193 12.9075 20.2405C14.6975 22.0592 17.0825 23.067 19.6225 23.0771L19.6925 24.9488V23.0771C24.955 23.0771 29.2375 18.7502 29.2375 13.433C29.2375 8.11589 24.955 3.78893 19.6925 3.78893Z",
    fill: "#00BAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsCounter1);
export default __webpack_public_path__ + "static/media/about-us-counter-1.7c32b983d142626e8b8e057cbb084891.svg";
export { ForwardRef as ReactComponent };